module.exports = __webpack_public_path__ + "static/media/Dan.9bf4a525.jpg";